<template>
  <v-layout row wrap my-3 mx-5>
    <v-flex xs12>
      <v-card class="pa-2 mb-5 elevation-6">
        <v-card-title class="headline white--text primary" >
          Whatsapp Mass Campaign
        </v-card-title>
        <v-card-actions class="px-3">
          <v-btn
              :loading="loading"
              color="primary"
              dark
              @click="pickFile ()"
            >
              Upload
            <v-icon right dark>cloud_upload</v-icon>
          </v-btn>
          <v-text-field
              label="file"
              v-model="name"
              readonly
              disabled
              class="mx-2"
            ></v-text-field>
            <input
              type="file"
              style="display: none"
              ref="file"
              accept="csv/*"
              @change="onFilePicked"
            >
            <v-btn
              :loading="loading"
              color="primary"
              dark
              @click="loadFile()"
            >
              Load
            <v-icon right dark>clear_all</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
        </v-card-actions>
        <v-layout row wrap>
          <v-flex xs12 pa-3>
            <v-data-table
              :headers="detailedViewsHeaders"
              :items="detailedViews"
              :loading="false"
              class="elevation-1"
            >
              <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.Name }}</td>
                <td class="text-xs-left">{{ props.item.Number }}</td>
                
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs12 pa-2>
            <v-btn  color="primary" dark>Send Message to All</v-btn>
          </v-flex>
        </v-layout>
        </v-card>
        <v-card class="pa-2 mb-5 elevation-6">
          <v-card-title class="headline white--text primary" >
            Whatsapp Messages Per #
          </v-card-title>
        <v-layout row wrap pt-3 mb-2>
          
          <v-flex xs12 md12 px-3>
            <v-select
              :items="contactedNumbers"
              solo
              return-object
              v-model="selectedNumber"
              label="Select A Contact"
            ></v-select>
          </v-flex>
          <v-flex xs12 pa-3>
            <v-data-table
              :headers="messagesH"
              :items="messages"
              :loading="false"
              class="elevation-1"
            >
              <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
              <template slot="items" slot-scope="props">
                <td v-for="(p,i) in props.item" :key="p+i" class="text-xs-left">{{ p }}</td>
                
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs12 md6 px-3>
            <v-text-field
              label="Number"
              solo
              v-model="sNumber"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md6 px-3>
            <v-textarea
              solo
              label="Message"
              v-model="sMessage"
            ></v-textarea>
          </v-flex>
          <v-flex xs12 md6 px-3>
            <img :src="qr" alt="" srcset="">
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
          color="primary" 
          dark
          @click="sendMessage()"
          >
            send
            <v-icon right>send</v-icon>
          </v-btn>
          
        </v-card-actions>
      </v-card>

      
    </v-flex>
  </v-layout>
</template>

<script>
import Papa from 'papaparse'
import axios from 'axios';
import { uuid } from '@/customFunction';
import {firebase, db, auth} from '@/fb';


export default {
  data() {
    return {
      url:null,
      name:null,
      file:null,
      loading:false,
      sNumber:null,
      sMessage:null,
      csv:null,
      qr:null,
      messagesH:[],
      messages:[],
      detailedViewsHeaders:[],
      detailedViews:[],
      contacts:[],
      contactedNumbers:[],
      selectedNumber:null,
      selectedNumberChat:null,
      chatMessages:[],
      myMSGS:[],
      clientMSGS:[],
    }
  },
  methods: {
    sendToAll(){

    },
    sendMessage(){
      if (!this.sNumber || !this.sMessage) {
        return
      }
      let token = 'upzjdoldmyhi9xyz'
      axios.get(`https://eu10.chat-api.com/instance37583/status?token=${token}`)
      .then(resp=>{
        console.log('------------------------------------');
        console.log(resp);
        this.qr = resp.data.qrCode
        if (resp.data.accountStatus == 'authenticated') {
          var headers = {
            'Accept': 'application/json'
          }
          let post = {
            phone:parseInt(this.sNumber),
            body:this.sMessage
          }
          axios.post(`https://eu10.chat-api.com/instance37583/sendMessage?token=${token}`, post, {headers: headers})
          .then(resp=>{
            if (resp.data.sent) {
              console.log(resp.data)
              let uid = uuid()
              db.ref(`whatsapp/numbers/${post.phone}`)
              .update({
                number:post.phone,
              })
            }
          })
        }
        console.log('------------------------------------');
      })
      
    },
    picMessage(){
      db.ref(`whatsapp/numbers`)
      .on('value', x=>{
        console.log('------------------------------------');
        console.log(x.val());
        let n = x.val()
        for (const key in n) {
          if (n.hasOwnProperty(key)) {
            const contact = n[key];
            this.contacts.push(contact)
            this.contactedNumbers.push({
              text:contact.number,
              value:contact.number,
            })

          }
        }
        console.log(this.contactedNumbers);
        this.updateMsgs()
      })
    },
    pickFile () {
      this.$refs.file.click ()
    },
    loadFile(){
      console.log('------------------------------------');
      console.log(this.csv);
      console.log('------------------------------------');
      this.csv.meta.fields.forEach(el => {
        this.detailedViewsHeaders.push({
          text:el,
          value:el
        })
      });
      this.detailedViews = this.csv.data
    },
    onFilePicked (e) {
			const files = e.target.files
			if(files[0] !== undefined) {
				const fr = new FileReader ()
				fr.readAsDataURL(files[0])
				fr.addEventListener('load', () => {
          this.name = files[0].name
					this.url = fr.result
          this.file = files[0] // this is an image file that can be sent to server...
          Papa.parse(this.file, {
            header: true,
            complete: (d)=>{
              this.csv = d
            }
          })
				})
			} else {
				this.name = null
				this.fule = null
				this.url = null
			}
    },
    updateMsgs(){
      if (!this.selectedNumber) {
        return
      }
      this.messages = []
      this.messagesH = []
      let contact = this.contacts.filter(x=> x.number = this.selectedNumber.value)
      let messages = contact[0].messages
      console.log(messages)

      for (const key in messages) {
        if (messages.hasOwnProperty(key)) {
          const message = messages[key];
          this.messages.push(message)
        }
      }
      console.log('------------------------------------');
        
      console.log(this.messages);
      console.log('------------------------------------');
      let h = Object.keys(this.messages[0])
      h.forEach(l=>{
        this.messagesH.push({
          text:l,
          value:l
        })
      })
    },
    chat(){
      this.loading = true
      db.ref('whatsapp/numbers/' + this.selectedNumberChat.value)
      .on('value', c=>{
        this.chatMessages = []
        let contact = c.val()
        console.log(contact)
        let messages = contact.messages
        for (const key in messages) {
          if (messages.hasOwnProperty(key)) {
            const message = messages[key];
            this.chatMessages.push(message)
          }
        }
        console.log('------------------------------------');
        console.log(this.chatMessages);
        let ownmsgs = this.chatMessages.filter(msg=> msg.author == this.chatMessages[0].author)
        ownmsgs.forEach(x=>{
          x.own = true
        })
        this.loading = false
        console.log('------------------------------------');
      })
    }
  },
  watch:{
    selectedNumber(){
      this.messages = []
      this.messagesH = []
      let contact = this.contacts.filter(x=> x.number = this.selectedNumber.value)
      let messages = contact[0].messages
      console.log(messages)

      for (const key in messages) {
        if (messages.hasOwnProperty(key)) {
          const message = messages[key];
          this.messages.push(message)
        }
      }
      console.log('------------------------------------');
        
      console.log(this.messages);
      console.log('------------------------------------');
      let h = Object.keys(this.messages[0])
      h.forEach(l=>{
        this.messagesH.push({
          text:l,
          value:l
        })
      })
    },
    selectedNumberChat(){
      this.chat()
    }
  },
  created() {
    this.picMessage()
  }
}
</script>

<style>

</style>
